export const es = {
  returnLineItems: {
    refund: "Reembolso(s)",
    exchange: "Cambio(s)",
    discount: "Descuento(s)",
  },
  returnStoreAddress: {
    mapButton: "Ver en el mapa",
  },
  returnRequestDate: {
    label: "Tu solicitud de devolución se realizó el {{date}} a las {{time}}",
  },
  actions: {
    continue: "Continuar",
  },
  "order-identification": {
    title: "Sigue tu pedido",
    description: "Introduce los detalles de tu pedido para rastrear tu paquete",
    fields: {
      "zip-code": {
        title: "Código postal",
        description: "Introduce tu código postal de entrega",
        required: "El código postal es obligatorio",
      },
      email: {
        title: "Dirección de correo electrónico",
        description: "Ingrese el correo electrónico utilizado en su pedido",
        required: "La dirección de correo electrónico es obligatoria",
      },
      both: {
        title: "Código postal o correo electrónico",
        description: "Introduzca su código postal de entrega o el correo electrónico usado en su pedido",
        required: "El código postal o el correo electrónico es obligatorio",
      },
      "tracking-number": {
        title: "Número de pedido",
        description: "Introduce tu número de pedido",
        required: "El número de pedido es obligatorio",
      },
    },
    errors: {
      "unknown-order": {
        title: "Número de pedido desconocido",
        description: "No se encontró el número de pedido, por favor verifícalo",
      },
      "search-error": {
        title: "Error de búsqueda",
        description:
          "No pudimos encontrar el pedido. Por favor, inténtalo más tarde.",
      },
    },
  },
  delivery: "Entrega",
  "parcel-history": "Historial del paquete",
  "order-details": {
    title: "Detalles del pedido",
    "tracking-number": "Número de seguimiento",
    "order-number": "Número de pedido",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Fecha estimada de entrega",
      deliveredOn: "Entregado el",
      from: "del",
      to: "al",
    },
  },
  deliveryAddress: {
    title: "Dirección de entrega:",
    titlePickup: "Dirección del punto de recogida:",
    orderDetails: {
      title: "Detalles del pedido:",
      trackingNumber: "Número de seguimiento:",
      orderNumber: "Número de pedido:",
      orderDate: "Fecha del pedido:",
    },
  },
  pickupPoint: {
    title: "Punto de recogida",
    openingHours: "Horario de apertura:",
    closed: "Cerrado",
    directions: "Direcciones",
    days: {
      monday: "Lunes:",
      tuesday: "Martes:",
      wednesday: "Miércoles:",
      thursday: "Jueves:",
      friday: "Viernes:",
      saturday: "Sábado:",
      sunday: "Domingo:",
    },
  },
  wallet: {
    warningNotEnabled: "Debe activar Wallet en la configuración de su tienda",
  },
  crossSell: {
    youMightAlsoLike: "También te puede gustar",
  },
  "rate-order": {
    "order-recap": {
      title: "Tu pedido",
      "tracking-label": "Número de seguimiento:",
      "order-label": "Número de pedido:",
    },
    form: {
      title: "Califica tu entrega",
      "rating-label": "Califica tu experiencia de entrega",
      "comment-label": "Comentario (opcional)",
      "comment-placeholder": "Comparte tu experiencia con nosotros…",
      "submit-cta": "Enviar mi valoración",
      "update-cta": "Actualizar mi valoración",
      "rating-required": "Por favor, selecciona una valoración.",
    },
    "thank-you": {
      title: "¡Gracias por tu opinión!",
      description:
        "Tu valoración se ha guardado. Nos ayudará a mejorar la experiencia de entrega.",
    },
    errors: {
      "invalid-token": {
        title: "Enlace no válido o caducado",
        description:
          "Este enlace ya no es válido. Ábrelo de nuevo desde tu último correo de seguimiento.",
      },
      submit: {
        title: "Algo ha salido mal",
        description:
          "No pudimos guardar tu valoración. Por favor, inténtalo de nuevo más tarde.",
      },
    },
  },
  shippingInstructions: {
    colissimo:
      "Ahora puede imprimir su etiqueta de devolución y dejar su paquete en el punto de relevo Colissimo más cercano.",
    chronoShop2Shop:
      "Ahora puede imprimir su etiqueta de devolución y dejar su paquete en el punto de relevo Chronopost más cercano.",
    ups: "Ahora puede imprimir su etiqueta de devolución y dejar su paquete en el punto de relevo UPS más cercano.",
    customerCarrier:
      "Ahora puede enviar su paquete de devolución al transportista de su elección.",
    merchantCarrier:
      "Nosotros le enviaremos una etiqueta de devolución por correo electrónico en los 1 a 3 días hábiles.",
    returnToStore:
      "Ahora puede imprimir su etiqueta de devolución y dejar su paquete en la tienda más cercana.",
    malca:
      "Ahora puede imprimir su etiqueta de devolución y dejar su paquete en el punto de relevo Malca más cercano.",
    tnt: "Ahora puede imprimir su etiqueta de devolución y dejar su paquete en el punto de relevo TNT más cercano.",
    bonDeRetour:
      "Su albarán de devolución está listo. Ahora puede imprimirlo y usarlo para su devolución.",
    unknownCarrier:
      "Ya puede imprimir su etiqueta de devolución y enviar su paquete con el transportista indicado en la etiqueta.",
  },
  downloadLabel: {
    label: "Descargar mi etiqueta",
    bonDeRetour: "Descargar mi albarán de devolución",
  },
  shippingInstructionsTitle: {
    shippingLabel: "Su etiqueta de envío está lista",
    bonDeRetour: "Su hoja de devolución está lista",
  },
} as const;
